import React, { FC } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../../route_with_sub_routes/RouteWithSubRoutes';
import { connect } from 'react-redux';
import { withUserType } from '../../withUserType';

const TroubleshootingOverviewPage: FC<any> = ({
	childRoutes,
	companyConfig,
	userType,
}): React.ReactElement => {
	const basePath = `/${userType}/workflows/troubleshooting/overview`;

	return (
		<div>
			<div>
				<Route
					path={basePath}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `${basePath}/all`,
							}}
						/>
					)}
				/>
				{childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps)(TroubleshootingOverviewPage))
);
